<template>
  <div style="/*margin-left: 20px; */ /* margin-right: 20px;*/ margin-top: auto; height: 100%; width: 100%">
    <div class="code-box-border shadow-sm" style="margin-bottom: 20px; margin-top:35px; height: 75%;">
      <div class="tab-content" id="myTabContent">
        <div class="tab-pane fade show active" id="daily" role="tabpanel" aria-labelledby="daily-tab">
          <app-numbers-list :type="'daily'" :numbersList="numbers.daily"></app-numbers-list>
        </div>
        <div class="tab-pane fade" id="weekly" role="tabpanel" aria-labelledby="weekly-tab">
          <app-numbers-list :type="'weekly'" :numbersList="numbers.weekly"></app-numbers-list>
        </div>
        <div class="tab-pane fade" id="monthly" role="tabpanel" aria-labelledby="monthly-tab">
          <app-numbers-list :type="'monthly'" :numbersList="numbers.monthly"></app-numbers-list>
        </div>
        <div class="tab-pane fade" id="yearly" role="tabpanel" aria-labelledby="yearly-tab">
          <app-numbers-list :type="'yearly'" :numbersList="numbers.yearly"></app-numbers-list>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/babel">
  import NumbersList from './numbers-list.vue';
  import axios from 'axios';
  import { mapState, mapActions } from 'vuex'
  import { NumbersModel } from '../models/numbers';

  export default {
        data() {
            return {}
        },
        computed: mapState(['numbers']),
        created: async function () {
          //console.dir(this.numbers);
          //this.onGetNumbers();
          //var id = this.$route.params.id;
          //this.$store.dispatch('getNumbers', {type: 'daily', id: this.$route.params.id}).then(resp => { /* do someting */ }).catch(err => { console.log(err)});
          //this.$store.dispatch('getNumbers', {type: 'weekly', id: this.$route.params.id}).then(resp => { /* do someting */ }).catch(err => { console.log(err)});
          //this.$store.dispatch('getNumbers', {type: 'monthly', id: this.$route.params.id}).then(resp => { /* do someting */ }).catch(err => { console.log(err)});
          //this.$store.dispatch('getNumbers', {type: 'yearly', id: this.$route.params.id}).then(resp => { /* do someting */ }).catch(err => { console.log(err)});

          //console.log(this.$route.params.id);

          await NumbersModel.getNumbers('daily', this.$route.params.id).then(resp => { 
            /* do someting */ 
            NumbersModel.getNumbers('weekly', this.$route.params.id).then(resp => { /* do someting */ }).catch(err => { console.log(err)});
            NumbersModel.getNumbers('monthly', this.$route.params.id).then(resp => { /* do someting */ }).catch(err => { console.log(err)});
            NumbersModel.getNumbers('yearly', this.$route.params.id).then(resp => { /* do someting */ }).catch(err => { console.log(err)});
          })
          .catch(err => { console.log(err)});
        },
        components: {
            'app-numbers-list':NumbersList
        }
    }
</script>
<style scoped>

hr {
	margin-top: 10px;
    margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/numbers.vue